import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';

import { modelOf } from '../../../prop-types';
import CartStore from '../../../store/CartStore';
import ProductCollectionMatrixCell from '../ProductCollectionMatrixCell';

/**
 * Owns cell quantity state and observes the cart clear token.
 * Kept separate from stock/meta UI so clear-on-add does not re-render the rest of the cell.
 */
const ProductCollectionMatrixQuantityInput = ({
  cartStore,
  productId,
  matrixCellProduct,
  onQuantityNotify,
  onRenderTooltip,
  variantId,
}) => {
  const [localQuantity, setLocalQuantity] = useState('');
  const inputClearToken = cartStore.getMatrixInputClearToken(productId);

  useEffect(() => {
    setLocalQuantity('');
  }, [inputClearToken]);

  const handleProductQuantity = (cartProduct) => {
    const rawQty = cartProduct.qty;
    const qty =
      rawQty === '' || rawQty === false || rawQty === null ? 0 : Number(rawQty);
    const displayQty = qty === 0 ? '' : qty;

    setLocalQuantity(displayQty);
    onQuantityNotify({ id: variantId, qty });
  };

  return (
    <ProductCollectionMatrixCell
      product={matrixCellProduct}
      cellCount={1}
      onHandleProductQuantity={handleProductQuantity}
      onRenderTooltip={onRenderTooltip}
      value={localQuantity}
      propertyListRef={null}
    />
  );
};

ProductCollectionMatrixQuantityInput.propTypes = {
  cartStore: modelOf(CartStore).isRequired,
  productId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  matrixCellProduct: PropTypes.object.isRequired,
  onQuantityNotify: PropTypes.func.isRequired,
  onRenderTooltip: PropTypes.func.isRequired,
  variantId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};

export default observer(ProductCollectionMatrixQuantityInput);
